module.exports = __webpack_public_path__ + "static/media/gem.76d8c239.svg";